/**
 * Created by Administrator on 2017/9/15.
 */
import {msg} from '../common/config.js';
import {StorageUtil} from '../common/Auth.js';
import merge from 'webpack-merge'
import {store} from "../store/store";
// import {store} from '../store/store';

var CommonUtil = {
  mergeQueryClean(vm, queryObj) {
    vm.$router.push({
      query:merge({},queryObj)
    })
  },
  mergeQuery(vm, queryObj) {
    vm.$router.push({
      query:merge(vm.$route.query,queryObj)
    })
  },
  checkPlatform: function () { /*1: 安卓，0：pc*/
    try{
      if(window.navigator.userAgent) {
        if(window.navigator.userAgent.indexOf('Android') != -1 || window.navigator.userAgent.indexOf('iPhone') != -1) {
          return 1
        } else {
          return 0
        }
      }
    }catch (error){
      console.log('获取平台失败!!!')
    }
  },
  setInfo: function (text) {
    try{
      layui.use(['layer'], function () {
        var layer = layui.layer;
        layer.msg(text, {time: 1000, skin: 'demo-class'});
      });
    }catch(e){
      console.log(e.message);
    }
  },
  deepCopy: function (data) {
    var type = this.getType(data);
    var obj = null;
    if (type !== 'array' && type !== 'object') {
      return data
    } else if (type === 'object') {
      obj = {};
      for (var key in data && Object.hasOwnProperty(key)) {
        obj[key] = this.deepCopy(data[key])
      }
    } else if (type === 'array') {
      obj = [];
      for (var i = 0; i < data.length; i++) {
        obj.push(this.deepCopy(data[i]))
      }
    }
    return obj;
  },
    getHashParams: function(){
      var url = window.location.hash;
      url = url.substring(1);
      var values = url.split("&");
      var params = {};
      for (var i = 0; i < values.length; i++) {
            var v = values[i];
            var p = v.split("=");
          params[p[0]]=p[1];
      }
      return params;
    },
  getURLParams: function () {
    let params={};
    let url = decodeURIComponent(window.location.href);
    let index = url.indexOf('?');
    if(index>=0){
      let paramStr=url.substring(index+1);
      let arr=paramStr.split('&');
      arr.forEach(item=>{
        item=item.trim();
        let i=item.indexOf('=');
        if(i>0&&i<item.length-1){
          params[item.substring(0,i).trim()]=item.substring(i+1).trim();
        }
      })
    }
    return params;
  },
  deleteURLParams:function (paramNameArr) {
    if(!paramNameArr||paramNameArr.length==0){
      return;
    }
    let url = window.location.href;
    let index = url.indexOf('?');
    if(index>=0){
      let isDel=false;
      let paramStr=url.substring(index+1);
      let newParamStr='&';
      let arr=paramStr.split('&');
      arr.forEach(item=>{
        let i=item.trim().indexOf('=');
        if(i<=0){
          newParamStr+=item;
        }else if(paramNameArr.indexOf(item.trim().substring(0,i).trim())<0){
          newParamStr+=item;
        }else {
          isDel=true;
        }
      });
      if(isDel){
        newParamStr='?'+newParamStr.substring(1);
        let newUrl=url.substring(0,index);
        if(newParamStr.length>1){
          newUrl+=newParamStr;
        }
        location.href = newUrl;
      }
    }
  },
  //更换url参数
  changeURLPar: function (jsonObj) {
    var url = window.location.href;
    var newUrl = "";
    for (var key in jsonObj) {
      var name = key;
      var value = jsonObj[key];
      var reg = new RegExp("(^|)" + name + "=([^&]*)(|$)");
      var tmp = name + "=" + value;
      if (url.match(reg) != null) {
        newUrl = url.replace(eval(reg), tmp);
      } else {
        if (url.match("[\?]")) {
          newUrl = url + "&" + tmp;
        } else {
          newUrl = url + "?" + tmp;
        }
      }
      url = newUrl;
    }
    location.href = newUrl;
  },
  //更换过期Code
  changeExpiredCode: function (thisStr,store) {
    var urlCode = thisStr.$route.query.code || "";
    if(urlCode!="" && store.chooseArea!=null && urlCode!=store.chooseArea.code){
      CommonUtil.changeURLPar({"code":store.chooseArea.code});
      return true;
    }else{
      return false;
    }
  },
  //清空url并更换参数
  changeURLParClean: function (jsonObj) {
    var url = window.location.href.split("?")[0];
    var newUrl = "";
    for (var key in jsonObj) {
      var name = key;
      var value = jsonObj[key];
      var reg = new RegExp("(^|)" + name + "=([^&]*)(|$)");
      var tmp = name + "=" + value;
      if (url.match(reg) != null) {
        newUrl = url.replace(eval(reg), tmp);
      } else {
        if (url.match("[\?]")) {
          newUrl = url + "&" + tmp;
        } else {
          newUrl = url + "?" + tmp;
        }
      }
      url = newUrl;
    }
    location.href = newUrl;
  },
  //保存被挤下线后的url
  saveRepeatLoginUrl:function () {
    var url=window.location.href;
    StorageUtil.storeString("repeatLoginUrl",url);
  },

  initStore: function (store, data) {
    for (var sonData in data) {
      store[sonData] = data[sonData]
    }
  },
  copyArr: function (list, isCopyArr) {
    var newArr = [];
    for (var i = 0; i < list.length; i++) {
      var obj = {};
      for (var key in list[i]) {
        if (list[i][key] instanceof Array && !isCopyArr) {
          obj[key] = this.copyArr(list[i][key]);
        } else {
          obj[key] = list[i][key]
        }
      }
      newArr.push(obj)
    }
    return newArr
  },

  //去掉空格
  Trim(str){
    var result = str.replace(/\s/ig, '');
    return result;
  },
  /**
   * 获取一个对象的所有属性字符串
   * @param obj
   * @returns {*对象的属性字符串(格式:key1=value1&key2=value2.....,如果没有则返回null)}
   */
  getAllProperty: function (obj) {
    if (obj == null || obj == undefined) {
      return '';
    }
    var propertys = "&";
    for (var Key in obj) {
      if (obj[Key] == null || obj[Key] == undefined || obj[Key].length == 0) {
        continue;
      }
      if (propertys == null) {
        propertys = Key + '=' + obj[Key];
      } else {
        propertys += '&' + Key + '=' + obj[Key];
      }
    }
    if (propertys === '&') {
      return '';
    }
    return propertys;
  },
  copyObject: function (source) {
    return JSON.parse(JSON.stringify(source));
  },

  /**
   * 移除对象属性
   * @param obj 需要移除属性的对象
   * @param property 需要移除的属性名
   * @param storageKey 保存到storage的key值,如果存在则保存到storage,如果不存在则不会保存
   * @returns {*}
   *
   */
  removeObjectProperty: function (obj, property, storageKey) {
    if (obj == null) {
      return null;
    } else {
      if (property == null || obj[property] == undefined) {
        if (storageKey != null && storageKey != undefined) {
          StorageUtil.storeObject(storageKey, obj);
        }
        return obj;
      } else {
        delete obj[property];
        if (storageKey != null && storageKey != undefined) {
          StorageUtil.storeObject(storageKey, obj);
        }
        return obj;
      }
    }
  },

  /**
   * 判断数组是否已包含某元素
   * @param arr 数组
   * @param obj
   * @returns {boolean}
   */
  contains: function (arr, obj) {
    if (arr == null || arr.length == 0) {
      return false;
    } else {
      var i = arr.length;
      while (i--) {
        if (arr[i] === obj || JSON.stringify(arr[i]) == JSON.stringify(obj)) {
          return true;
        }
      }
      return false;
    }
  },

  removeArray: function (arr, obj) {
    var newArr = [];
    for (var i = 0; i < arr.length; i++) {
      if (JSON.stringify(arr[i]) != JSON.stringify(obj)) {
        newArr.push(arr[i]);
      }
    }
    arr = newArr;
    return newArr;
  },
  /**
   * 清空input元素数组里的text和password的值
   * @param inputArr
   * @param overlookDisabled 是否忽略被禁用的元素,默认为false
   */
  cleanInput: function (inputArr, overlookDisabled) {
    if (inputArr != null && inputArr != undefined && inputArr.length > 0) {
      for (var i = 0; i < inputArr.length; i++) {
        if (overlookDisabled != null && overlookDisabled != undefined && overlookDisabled == true && inputArr[i].disabled) {
          continue;
        } else if (inputArr[i].type == 'text' || inputArr.type == 'password') {
          inputArr[i].value = '';
        }
      }
    }
  },
  /**
   * 获取字符串的字节长度(一个汉字算2个字节)
   * @param str
   * @returns {number}
   */
  getByteLength: function (str) {
    var len = 0;
    if (str != "") {
      for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i);
        if ((c >= 0x0001 && c <= 0x007e) || (0xff60 <= c && c <= 0xff9f)) {
          len++;
        } else {
          len += 2;
        }
      }
    }
    return len;
  },

  /**
   * 按字节长度截取字符串
   * @param str 需要截取的字符串
   * @param length 字节长度
   * @returns {string}
   */
  substringByByteLength: function (str, length) {
    if (length <= 0 || str == '') {
      return '';
    }
    var len = this.getByteLength(str);
    var newStr = '';
    if (len <= length) {
      newStr = str;
    } else {
      var temp = 0;
      for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i);
        if ((c >= 0x0001 && c <= 0x007e) || (0xff60 <= c && c <= 0xff9f)) {
          temp++;
        } else {
          temp += 2;
        }
        if (temp <= length) {
          newStr += str.substring(i, i + 1);
        } else {
          break;
        }
      }
    }
    return newStr;
  },

  getUuid: function () {//获取UUId
    var s = [];
    var hexDigits = "0123456789abcdef";
    for (var i = 0; i < 36; i++) {
      s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = "4";  // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);  // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = "-";

    var uuid = s.join("");
    return uuid;
  },

  isIsbn10: function (isbn) {
    if (isbn == null || isbn == undefined || isbn.length != 10) {
      return false;
    } else {
      return /^[0-9]{9}[0-9X]{1}$/.test(isbn);
    }
  },

  isIsbn13: function (isbn) {
    if (isbn == null || isbn == undefined || isbn.length != 10) {
      return false;
    } else {
      return /^[0-9]{13}$/.test(isbn);
    }
  },

  /**
   * 将13位isbn转换为10位isbn
   * @param isbn
   * @returns {string|*}
   */
  toIsbn10: function (isbn) {
    //如果是13位的纯数字isbn,则转换为10位,否则直接返回
    if (this.isIsbn13(isbn)) {
      isbn = isbn.substring(3, isbn.length - 1);
      var sum = 0, temp = 10;
      for (var i = 0; i < isbn.length; i++) {
        sum += (parseInt(isbn.substring(i, i + 1)) * temp);
        temp--;
      }
      var last = sum % 11;
      //如果last为0,则校验位为0;如果last为1,则校验位为X;如果last为其他数,则校验位为将last取11的补数
      var check = last == 0 ? "0" : (last == 1 ? "X" : (11 - last) + "");
      isbn += check;
      return isbn;
    } else {
      return isbn;
    }
  },

  /**
   * 将10位的isbn转换为13位isbn
   * @param isbn
   * @returns {*}
   */
  toIsbn13: function (isbn) {
    //如果是10位的标准isbn,则转换为13位,否则直接返回
    if (this.isIsbn10(isbn)) {
      isbn = isbn.substring(0, isbn.length - 1);
      isbn = "978" + isbn;
      var a = 0, b = 0, c = 0, d = 0;
      for (var i = 0; i < isbn.length; i++) {
        var x = parseInt(isbn.substring(i, i + 1));
        if (i % 2 == 0) {
          a += x;
        } else {
          b += x;
        }
      }
      c = a + 3 * b;
      d = 10 - c % 10;
      if (d == 10) {
        d = 0;
      }
      isbn = isbn + d;
      return isbn;
    } else {
      return isbn;
    }
  },
  /**
   * 根据元素配置列表获取当前元素的下一元素
   * @param cur  当前元素
   * @param fullConfig 元素配置列表
   * @param skipNotEmpty 是否跳过非空值的元素
   */
  getNextEL: function (cur, fullConfig, skipNotEmpty) {
    var config = getNoneUndefinedConfigList(fullConfig);
    for (var i = 0; i < config.length; i++) {
      let el = Array.isArray(config[i]) ? config[i][0] : config[i];
      if (i === config.length - 1) { //如果是最后一个元素，则返回空
        return null;
      }
      if (!skipNotEmpty) {
        let props = el.getProps ? el.getProps() : null;
        if (props.required && (props.value === null || props.value === '')) {//查找第一个空值的必填元素，如果有即返回
          if (el != null && el.type == 'button' && this.isIE()) {
            this.setCursorPositionToLast(cur.getInput());
          }
          return el;
        }
      }

      if (cur === el) {//匹配到当前元素，返回下一元素
        let nextEl = config[i + 1];
        if (!skipNotEmpty) {
          if (nextEl != null && nextEl.type == 'button' && this.isIE()) {
            this.setCursorPositionToLast(cur.getInput());
          }
          return nextEl;
        } else {
          let nextElProps = nextEl.getProps ? nextEl.getProps() : null;
          if (nextElProps == null) {
            if (nextEl != null && nextEl.type == 'button' && this.isIE()) {
              this.setCursorPositionToLast(cur.getInput());
            }
            return nextEl;
          } else {
            if (nextElProps.value != null && nextElProps.value !== '') {
              return this.getNextEL(nextEl, config, skipNotEmpty);
            } else {
              if (nextEl != null && nextEl.type == 'button' && this.isIE()) {
                this.setCursorPositionToLast(cur.getInput());
              }
              return nextEl;
            }
          }
        }
      }
    }
    return null;
  },
  isIE: function () {
    return !!window.ActiveXObject || "ActiveXObject" in window;
  },
  isChrome: function () {
    return navigator.userAgent.indexOf("Chrome") > -1;
  },
  /**
   * 将光标定位到元素末尾
   * @param input dom元素
   */
  setCursorPositionToLast: function (input) {
    this.setCursorPosition(input, input.value.length);
  },
  /**
   * 设置光标位置
   * @param input dom元素对象
   * @param position 光标位置
   */
  setCursorPosition: function (input, position) {
    this.setSelectionRange(input, position, position);
  },
  /**
   * 设置元素文本选中项
   * @param input dom元素对象
   * @param selectionStart 选中开始位置
   * @param selectionEnd 选中结束位置
   */
  setSelectionRange: function (input, selectionStart, selectionEnd) {
    if (input.setSelectionRange) {
      input.focus();
      input.setSelectionRange(selectionStart, selectionEnd);
    } else if (input.createTextRange) {
      var range = input.createTextRange();
      range.collapse(true);
      range.moveEnd('character', selectionEnd);
      range.moveStart('character', selectionStart);
      range.select();
    }
  },
  clearSelections: function () {
    if (window.getSelection()) {
      window.getSelection().removeAllRanges();
    } else {
      document.selection.empty();
    }
  },
  /**
   * 格式化小数
   * @param num 需要格式化的数字
   * @param decimals 小数点位数(大于等于0)
   * @param returnNum 是否返回数字类型(默认为false,返回两位小数的字符串.)
   * @returns {String} 格式化后的小数字符串(四舍五入)
   */
  formatDecimalsNum: function (num, decimals, returnNum) {
    //如果参数小数位为空或者小于0,则默认为0,为0即表示取整数
    if (decimals == null || decimals.length == 0 || parseInt(decimals) < 0) {
      decimals = 0;
    }
    //如果要转换的数字不存在,则默认返回0,补上小数位
    if (num == null || num.length == 0 || num == "" || num == "undefined") {
      var n = "0";
      for (var i = 0; i < decimals; i++) {
        if (i == 0) {
          n += ".";
        }
        n += "0";
      }
      if (returnNum != null && returnNum != undefined && returnNum == true) {
        n = parseFloat(n);
      }
      return n;
    }
    var numStr = num.toString().trim();
    var minus = "";//如果第一位为负号,则单独用minus存下负号,数字部分当做正数计算
    if (numStr.substring(0, 1) == "-") {
      minus = "-";
      numStr = numStr.substring(1);
    }
    var newNum;
    var temp = numStr.indexOf(".");
    if (temp != -1) {//如果有小数点
      var num1 = numStr.substring(0, temp);//小数点前部分
      var num2 = numStr.substring(temp + 1);//小数点后部分
      num1 = num1.replace(/[^0-9]/g, "");//替换非数字字符
      num2 = num2.replace(/[^0-9]/g, "");
      if (num1 == "" || num1.length == 0) {
        num1 = "0";
      }
      if (num2 == "" || num2.length == 0) {
        num2 = "0";
      }
      if (parseInt(num1) == 0 && parseInt(num2) == 0) {//避免-0.0之类情况
        minus = "";
      }
      //得到纯小数字符串
      newNum = parseInt(num1).toString() + "." + num2;
      //四舍五入
      newNum = (Math.round(Number(newNum) * Math.pow(10, decimals)) / Math.pow(10, decimals)).toString();
      //四舍五入后再次补充小数位
      if (decimals > 0) {
        var deci = "";
        if (newNum.indexOf(".") == -1) {
          for (var i = 0; i < decimals; i++) {
            deci += "0";
          }
          newNum = newNum + "." + deci;
        } else {
          deci = newNum.substring(newNum.indexOf(".") + 1);
          for (var i = deci.length; i < decimals; i++) {
            deci += "0";
          }
          newNum = newNum.substring(0, newNum.indexOf(".")) + "." + deci;
        }
      }
    } else {//如果没有小数位
      numStr = numStr.replace(/[^0-9]/g, "");
      if (numStr == "" || numStr.length == 0) {
        numStr = "0";
      }
      if (parseInt(numStr) == 0) {//避免-0的情况
        minus = "";
      }
      newNum = parseInt(numStr).toString();
      for (var i = 0; i < decimals; i++) {
        if (i == 0) {
          newNum += ".";
        }
        newNum += "0";
      }
    }
    var numStr = minus + newNum;
    if (returnNum != null && returnNum != undefined && returnNum == true) {
      numStr = parseFloat(numStr);
    }
    return numStr;
  },

  /**
   * 判断字符串是不是日期格式。如果是日期格式，则返回yyyy-MM-dd格式的日期字符串，否则返回null
   * @param dateStr 需要判断的日期字符串
   * @param isFormat 是否要格式化,默认为true
   * @returns {返回yyyy-MM-dd格式的日期字符串 或 null 或 "",如果不格式化,则返回yyyyMMdd格式}
   */
  isDate: function (dateStr, isFormat) {
    var regExp = [/[1-9][0-9]{3,7}$/,
      /[1-9][0-9]{3}年[0-9]{0,2}$/, /[1-9][0-9]{3}年[0-9]{1,2}月[0-9]{0,2}$/, /[1-9][0-9]{3}年[0-9]{1,2}月[0-9]{1,2}日$/,
      /[1-9][0-9]{3}-[0-9]{1,2}$/, /[1-9][0-9]{3}-[0-9]{1,2}-[0-9]{1,2}$/,
      /[1-9][0-9]{3}[.][0-9]{1,2}$/, /[1-9][0-9]{3}[.][0-9]{1,2}[.][0-9]{1,2}$/,
      /[1-9][0-9]{3}[/][0-9]{1,2}$/, /[1-9][0-9]{3}[/][0-9]{1,2}[/][0-9]{1,2}$/];
    var year = '', month = '', day = '';
    if (dateStr == null || dateStr == '' || dateStr.length == 0) {//如果为空,则返回空字符串
      return "";
    } else if (regExp[0].test(dateStr)) {//纯数字格式
      year = dateStr.substring(0, 4);
      if (dateStr.length == 5) {
        month = dateStr.substring(4, 5);
      } else if (dateStr.length == 6) {
        if (parseInt(dateStr.substring(4, 6)) <= 12) {
          month = dateStr.substring(4, 6);
        } else {
          month = dateStr.substring(4, 5);
          day = dateStr.substring(5, 6);
        }
      } else if (dateStr.length == 7) {
        if (parseInt(dateStr.substring(4, 6)) <= 12) {
          month = dateStr.substring(4, 6);
          day = dateStr.substring(6, 7);
        } else {
          month = dateStr.substring(4, 5);
          day = dateStr.substring(5, 7);
        }
      } else if (dateStr.length == 8) {
        month = dateStr.substring(4, 6);
        day = dateStr.substring(6, 8);
      }
    } else if (regExp[4].test(dateStr) || regExp[5].test(dateStr)
      || regExp[6].test(dateStr) || regExp[7].test(dateStr)
      || regExp[8].test(dateStr) || regExp[9].test(dateStr)) {//分隔符格式(仅支持 . - / 三种分隔符)
      var dateArr = [];
      if (dateStr.indexOf('-') != -1) {
        dateArr = dateStr.split("-");
      } else if (dateStr.indexOf('.') != -1) {
        dateArr = dateStr.split(".");
      } else if (dateStr.indexOf('/') != -1) {
        dateArr = dateStr.split("/");
      }
      year = dateArr[0];
      month = dateArr[1];
      if (dateArr.length > 2) {
        day = dateArr[2];
      }
    } else if (regExp[1].test(dateStr) || regExp[2].test(dateStr) || regExp[3].test(dateStr)) {//汉字yyyy年MM月dd日格式
      var dateArr = dateStr.split("年");
      year = dateArr[0];
      if (dateArr.length > 1) {
        var temp = dateArr[1];
        if (temp.indexOf('月') != -1) {
          var t = temp.split("月");
          month = t[0];
          if (t.length > 1) {
            day = t[1].replace(/[^0-9]/g, '');
          }
        } else {
          month = temp;
        }
      }
    } else {
      return null;
    }
    //月份不符合规则
    if (month != '' && (parseInt(month) > 12 || parseInt(month) < 1)) {
      return null;
    }
    //日份不符合规则
    if (day != '' && (parseInt(day) > 31 || parseInt(day) < 1)) {
      return null;
    }
    try {
      var date = new Date(year, month == '' ? 0 : month, day == '' ? 1 : day, 0, 0, 0);
      if (isFormat == null || isFormat == undefined || isFormat == true) {
        var formatDateStr = year;
        if (month == '') {
          formatDateStr += '-01';
        } else if (month.length == 1) {
          formatDateStr += '-0' + month;
        } else if (month.length == 2) {
          formatDateStr += '-' + month;
        }
        if (day == '') {
          formatDateStr += '-01';
        } else if (day.length == 1) {
          formatDateStr += '-0' + day;
        } else if (day.length == 2) {
          formatDateStr += '-' + day;
        }
        return formatDateStr;
      } else {
        if (month.length == 1) {
          month = '0' + month;
        }
        if (day.length == 1) {
          day = '0' + day;
        }
        return year + month + day;
      }
    } catch (e) {
      return null;
    }
  },
  /**
   * 比较两个日期(如果开始日期小于等于结束日期,则返回true,否则false)
   * @param beginDate 开始日期
   * @param endDate 结束日期
   * @returns {boolean}
   */
  compareDate: function (beginDate, endDate) {
    var start = new Date(beginDate.replace("-", "/").replace("-", "/"));
    var end = new Date(endDate.replace("-", "/").replace("-", "/"));
    if (end < start) {
      return false;
    } else {
      return true;
    }
  },
  //日期，在原有日期基础上，增加days天数，默认增加1天
  addDateDay:function(date, days){
      if(days == undefined || days == '') {
        days = 1;
      }
      var date = new Date(date);
      date.setDate(date.getDate() + days);
      var month = date.getMonth() + 1;
      var day = date.getDate();
      var mm = "'" + month + "'";
      var dd = "'" + day + "'";

      //单位数前面加0
      if(mm.length == 3) {
        month = "0" + month;
      }
      if(dd.length == 3) {
        day = "0" + day;
      }

      var time = date.getFullYear() + "-" + month + "-" + day
      return time;
  },

  /**
   * 比较两个日期(如果日期相等,则返回true,否则false)
   * @param beginDate 开始日期
   * @param endDate 结束日期
   * @returns {boolean}
   */
  isDateEqual: function (beginDate, endDate) {
    var start = new Date(beginDate.replace("-", "/").replace("-", "/"));
    var end = new Date(endDate.replace("-", "/").replace("-", "/"));
    if (end.getTime() != start.getTime()) {
      return false;
    }
    return true;
  },

  /**
   * 格式化馆号加条码号
   * @param number 传入的馆号和条码号组合(如果没有馆号则默认为当前馆号)
   * @returns {{belongLibraryHallCode, barNumber: string}}
   */
  formatHallCodeAndBarNumber: function (number) {
    var barNumber = number;
    var belongLibraryHallCode = StorageUtil.getObject("user").hallCode;
    if (/[A-Z]$/.test(number.charAt(0))) {
      //如果为馆号加条码号组成
      belongLibraryHallCode = number.substring(0, 4);
      barNumber = number.substring(4);
    }
    var code = '';
    var zeroNum = 7 - barNumber.toString().length;
    for (var i = 0; i < zeroNum; i++) {
      code += '0';
    }
    code += barNumber.toString();
    return {belongLibraryHallCode: belongLibraryHallCode, barNumber: code};
  },


//验证条码号
  validateHallCodeAndBarNumber: function (rule, value) {
    if (/[A-Z]{4}[0-9]{1,7}$/.test(value) && /[0-9]{1,7}$/.test(value)) {
      return null;
    } else {
      if (rule.msg == null) { //如果rule中为传msg，则使用默认msg(错误值)
        return msg.barNumberError;
      } else {
        return rule.msg;
      }
    }
  },


  /**
   * 格式化单号
   * @param code 需要格式化的单号
   * @param letter 单号前面的字母
   * @param len 单号数字部分长度
   * @returns {*格式化后的单号}
   */
  formatCode: function (code, letter, len) {
    if (code == '' || code == null) {
      return '';
    }
    code = code.toString();
    if (/[^0-9]$/.test(code.charAt(0))) {
      if (code.length <= letter.length || code.substring(0, letter.length) != letter) {
        return '';
      }
      code = code.substring(letter.length);
    }
    var num = len - code.length;//需要补0的个数
    for (var i = 0; i < num; i++) {
      code = "0" + code;
    }
    return letter + code;
  },
  /**
   * 格式化多种格式的单号
   * @param code 需要格式化的单号
   * @param letterArr 单号前面的字母部分格式数组
   * @param len 单号数字部分长度
   * @param defaultLetter 如果需要格式化的单号是纯数字时,默认拼接的字母
   * @returns {*格式化后的单号}
   */
  formatCodes: function (code, letterArr, len, defaultLetter) {
    if (code == '') {
      return '';
    }
    code = code.toString();
    var letter = '', number = '';
    if (/[^0-9]$/.test(code.charAt(0))) {
      for (var i = 0; i < letterArr.length; i++) {
        if (code.substring(0, letterArr[i].length) == letterArr[i]) {
          letter = letterArr[i];
          number = code.substring(letter.length);
          break;
        }
      }
      if (letter == '' || number == '') {
        return '';
      }
    } else {
      letter = defaultLetter;
      number = code;
    }
    var num = len - number.length;//需要补0的个数
    for (var i = 0; i < num; i++) {
      number = "0" + number;
    }
    return letter + number;
  },
  /**
   * 设置元素内的文本内容,并定时清空文本内容
   * @param ele 要设置的元素对象
   * @param tip 要设置的文本内容
   * @param timeout 清空文本间隔时间(单位:毫秒,如果小于等于0或者未传或者为null,则不会定时重置为'')
   */
  setResultTip: function (ele, tip, timeout) {
    ele.innerText = tip;
    if (timeout === null || timeout === undefined || timeout <= 0) {
      return;
    } else {
      setTimeout(() => {
        ele.innerText = '';
      }, timeout);
    }
  },
    //计算两个时间相差了几个小时
    getIntervalHour: function (startDate, endDate) {
        var ms = endDate.getTime() - startDate.getTime();
        if (ms < 0) return 0;
        return Math.floor(ms/1000/60/60);
    },
    //cname 名字
    //cvalue 值
    //exdays 时间            0.01大概25分钟
    setCookie:function (cname, cvalue, exdays){
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + "; " + expires+"; path=/" ;
    },
    //获取cookie
    getCookie:function (cname){
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for(var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while(c.charAt(0) == ' ') c = c.substring(1);
            if(c.indexOf(name) != -1) return c.substring(name.length, c.length);
        }
        return "";
    },
    //删除 cookie
    clearCookie:function (name){
        setCookie(name, "", -1);
    },


  //验证身份证
  checkIdCard: function (idCard) {
    if (!/^[0-9]{15}$/.test(idCard) && !/^[0-9]{17}([0-9]|X)$/.test(idCard)) {
      return "err";
    } else {
      return "yes";
    }
  },
  /**
   * 校验范围金额条件的大小
   * @param parameters 条件对象
   * @param minValueKey 最小金额的key
   * @param maxValueKey 最大金额的key
   * @param msgRef 错误消息显示的ref
   * @param successcallback 成功回调
   * @param failcallback 失败回调
   */
  checkRangeMoney: function (parameters, minValueKey, maxValueKey, msgRef, successcallback, failcallback) {
    if (parameters != null && parameters != undefined && parameters != '') {
      if (parameters[minValueKey] != null && parameters[minValueKey] != undefined
        && parameters[maxValueKey] != null && parameters[maxValueKey] != undefined) {
        if (parameters[minValueKey].length > 0 && parameters[maxValueKey].length > 0 && parseFloat(parameters[minValueKey]) > parseFloat(parameters[maxValueKey])) {
          msgRef[0].showError(msg.wrongDate);
          if (failcallback != null) {
            failcallback();
          }
          return;
        }
      }
    }
    if (successcallback != null) {
      successcallback();
    }
  },
  //获取屏幕的宽度与高度。
  getwinSize: function () {
    //getwinSize用于获取窗口的高度。
    var size = {};
    var winHeight = 0;
    var winWidth = 0;
    if (window.innerHeight) {
      winHeight = window.innerHeight;
      winWidth = window.innerWidth;
    } else if ((document.body) && (document.body.clientHeight)) {
      winHeight = document.body.clientHeight;
      winWidth = document.body.clientWidth;
    }
    //对body进行检测，获取浏览器窗口高度
    if (document.documentElement && document.documentElement.clientHeight) {
      winHeight = document.documentElement.clientHeight;
      winWidth = document.documentElement.clientWidth;
    }
    size = {
      winHeight: winHeight,
      winWidth: winWidth
    }
    return size;
  },
  /**
   * 图书馆级别排序
   */
  sortLibraryLevel: function (libraryLevelList) {
    var arr = [];
    arr = libraryLevelList
    for (var i = 0; i < arr.length; i++) {
      switch (arr[i].desc) {
        case "公共图书馆":
          arr[i].sortVal = 1;
          break;
        case "高校馆":
          arr[i].sortVal = 2;
          break;
        case "中小学馆":
          arr[i].sortVal = 3;
          break;
        case "乡镇文化站":
          arr[i].sortVal = 4;
          break;
        case "社区书屋":
          arr[i].sortVal = 5;
          break;
        case "农家书屋":
          arr[i].sortVal = 6;
          break;
        case "职工书屋":
          arr[i].sortVal = 7;
          break;
        case "无人书屋":
          arr[i].sortVal = 8;
          break;
        case "社会书屋":
          arr[i].sortVal = 9;
          break;
        case "共享书屋":
          arr[i].sortVal = 10;
          break;
        case "体验馆":
          arr[i].sortVal = 11;
          break;
      }
    }
    arr.sort((a, b) => {
      return a.sortVal - b.sortVal;
    })
  },
  /*//动态获取页面显示数据的条数；
  getSize: function (ele) {
    var objHeight = $(ele).height();
    var line = Math.floor(objHeight / 37);
    return line >= 2 ? line - 1 : 1;
  },*/

  getItemFromSelectListByValue: function (list, value) {
    var result = {desc: '', value: ''};
    for (var i = 0; i < list.length; i++) {
      if (value == list[i].value) {
        result = list[i]
        break;
      }
    }
    return result;
  },
  getTotalPage: function (totalCount, pageSize) {
    return Math.ceil(totalCount / pageSize);
  },
  /**
   * 格式化时间
   * @param now
   * @returns {string}
   */
  formatDate: function (now) {
    var time = new Date(now);
    var year = time.getFullYear();
    var month = (time.getMonth() + 1 < 10 ? '0' + (time.getMonth() + 1) : time.getMonth() + 1) + '';
    var date = time.getDate();
    var hour = time.getHours() % 12 == 0 ? 12 : this.getHours() % 12;//小时
    var minute = time.getMinutes();
    var second = time.getSeconds();
    return year + "" + month + "" + date + " " + hour + ":" + minute + ":" + second;
  },
  /**
   * @name  getTableData
   * @desc  纯JS前端分页方法
   * @param  {Number} page 当前页码，默认1
   * @param  {Number} pageSize 每页最多显示条数，默认10
   * @param  {Array} totalData 总的数据集，默认为空数组
   * @return {Object} {
          data,
          page, //当前页码
          pageSize, //每页最多显示条数
          length, //总的数据条数
          totalPage,//总页数
      }**/
  getTableData:function(pageNo = 1, pageSize = 10, totalData = []){
    const {length} = totalData;//计算数据总长度
    const totalPage = 1;
    const tableData = {
      data:[],//当前页展示数据，数组
      pageNo,//当前页码
      pageSize,//每页最多显示条数
      totalPage,//总页数
      length,//总的数据条数
    };
    if(pageSize >= length){ //pageSize大于等于总数据长度，说明只有1页数据或没有数据
      tableData.data = totalData;
      tableData.pageNo = 1;//直接取第一页
      tableData.totalPage  =1;//总共只有一页
    }else{ //pageSize小于总数据长度，数据不止1页
      if(length % pageSize === 0){
        tableData.totalPage = parseInt(length / pageSize);
      }else{
        tableData.totalPage = parseInt(length / pageSize) + 1;
      }
      const num = pageSize*(pageNo - 1);//计算当前页（不含）之前的所有数据总条数
      if(num < length){//如果当前页之前所有数据总条数小于（不能等于）总的数据集长度，则说明当前页码没有超出最大页码
        const startIndex = num;//当前页第一条数据在总数据集中的索引
        const endIndex = num + pageSize - 1;//当前页最后一条数据索引
        //当前页数据条数小于每页最大条数时，也按最大条数范围筛取数据
        tableData.data = totalData.filter((_, index)=> index>=startIndex && index<=endIndex);
      }else{//当前页码超出最大页码，则计算实际最后一页的page，自动返回最后一页数据
        const size = parseInt(length / pageSize); //取商
        const rest = length % pageSize;//取余
        if(rest >0){
          tableData.pageNo = size + 1;
          tableData.data = totalData.filter((_,index)=>index>=(pageNo*size)&&index<=length);
        }else if(rest === 0){
          tableData.pageNo = size;
          tableData.data = totalData.filter((_,index)=>index>=(pageSize*(size-1)) && index<=length);
        }
      }
    }
    return tableData;
  },
  /**
   *对象数组去重(根据对象属性是否重复去重)
   * @param arr 数组
   * @param name 去重的对象某个属性
   * @returns {*}
   */
  arrayUniqueObj: function (arr, name) {
    var hash = {};
    return arr.reduce(function (item, next) {
      hash[next[name]] ? '' : hash[next[name]] = true && item.push(next);
      return item;
    }, []);
  },

};

////忽略未渲染或禁用的元素
function getNoneUndefinedConfigList(fullConfig) {
  let result = [];
  for (var i = 0; i < fullConfig.length; i++) {
    var el = fullConfig[i];
    if (el === undefined || el === null || el.disabled) {
      continue;
    } else {
      result.push(el);
    }
  }
  return result;
};


/*对Date的扩展，将 Date 转化为指定格式的String * 月(M)、日(d)、12小时(h)、24小时(H)、分(m)、秒(s)、周(E)、季度(q)<br/>
 可以用 1-2 个占位符 * 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字) *
 eg: * (new Date()).pattern("yyyy-MM-dd hh:mm:ss.S")==> 2006-07-02 08:09:04.423
 * new Date().pattern("yyyy-MM-dd E HH:mm:ss") ==> 2009-03-10 二 20:09:04
 * new Date().pattern("yyyy-MM-dd EE hh:mm:ss") ==> 2009-03-10 周二 08:09:04
 * new Date().pattern("yyyy-MM-dd EEE hh:mm:ss") ==> 2009-03-10 星期二 08:09:04
 * new Date().pattern("yyyy-M-d h:m:s.S") ==> 2006-7-2 8:9:4.18
 */
Date.prototype.pattern = function (fmt) {
  var o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "h+": this.getHours() % 12 == 0 ? 12 : this.getHours() % 12, //小时
    "H+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    "S": this.getMilliseconds() //毫秒
  };
  var week = {"0": "/u65e5", "1": "/u4e00", "2": "/u4e8c", "3": "/u4e09", "4": "/u56db", "5": "/u4e94", "6": "/u516d"};
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  }
  if (/(E+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, ((RegExp.$1.length > 1) ? (RegExp.$1.length > 2 ? "/u661f/u671f" : "/u5468") : "") + week[this.getDay() + ""]);
  }
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    }
  }
  return fmt;
};


/**
 * 数组去重
 * @returns {Array}
 */
Array.prototype.unique = function () {
  // n为hash表，r为临时数组
  var n = {}, r = [];
  for (var i = 0; i < this.length; i++) {
    // 如果hash表中没有当前项
    if (!n[this[i]]) {
      // 存入hash表
      n[this[i]] = true;
      // 把当前数组的当前项push到临时数组里面
      r.push(this[i]);
    }
  }
  return r;
};

export {CommonUtil};
